import React from "react";
import { reviewsData } from "../components/Data";

const Reviews = () => {
  return (
    <div className="md:hidden bg-neutralLight">
      <div className="container mx-auto py-16">
        <h2 className="text-textPrimary font-bold text-[1.8rem] md:text-3xl text-left mx-auto mb-8">
          Lorem ipsum dolor sit amet consectetur
        </h2>
        <hr className="border border-boderLight opacity-55 mb-8" />
        {reviewsData.map((item) => (
          <div
            key={item.id}
            className="flex items-center rounded-[4rem] p-2.5 shadow-xl gap-4 mb-8"
          >
            <img
              src={item.img}
              alt={item.title}
              className="w-[70px] h-[70px] border-[3px] border-textPrimary rounded-full mx-auto object-cover text-center"
            />
            <div className="grid">
              <p className="font-bold poppins text-textPrimary">{item.title}</p>
              <p className="font-extralight poppins text-textPrimary text-">
                {item.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Reviews;
